import { useMemo } from 'react';
import { useChainOrderStore } from './ChainOrderStore.js';
import { maxChainsToOrder } from './createChainOrderStore.js';
export const useChainOrder = (type) => {
    const [chainOrder, setChain] = useChainOrderStore((state) => [
        state.chainOrder[type],
        state.setChain,
    ]);
    const limitedChainOrder = useMemo(() => chainOrder.slice(0, maxChainsToOrder), [chainOrder]);
    return [limitedChainOrder, setChain];
};
//# sourceMappingURL=useChainOrder.js.map